const jobList = [
    { key: "immigration", label: "출입국" },
    { key: "permission", label: "인허가" },
    { key: "corporation", label: "법인설립" },
    { key: "license", label: "등록면허" },
    { key: "investigation", label: "사실조사" },
    { key: "certification", label: "산재/보상" },
    { key: "appeal", label: "행정심판" },
    { key: "realestate", label: "부동산" },
    { key: "car", label: "자동차" },
    { key: "general", label: "일반행정" },
    { key: "school", label: "학교" },
    { key: "factory", label: "공장/기업" },
    { key: "government", label: "정부지원" },
    { key: "translation", label: "번역" },
    { key: "maritime", label: "해사행정" },
    { key: "etc", label: "기타" }
];

export default jobList;
